export var headers = {
	"Project-Id-Version": "open-xchange-appsuite-gdpr",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2018-06-19 17:04+0200",
	"Last-Translator": "Viktor Pracht <viktor.pracht@open-xchange.com>",
	Language: "",
	"Language-Team": "",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0"
};
export default {
	headers: headers,
	"\u0000Change settings\u0001": [
	"Einstellungen ändern"
],
	"\u0000I agree\u0001": [
	"Ich stimme zu"
],
	"\u0000Privacy\u0001": [
	"Datenschutz"
],
	"\u0000This service uses cookies. By clicking on \"I agree\" or by continuing to use the service you agree to the use of the cookies. Alternatively, you can change your cookie preferences by clicking on \"Change settings\".\u0001": [
	"Dieser Dienst verwendet Cookies, um den Dienst optimal zu gestalten und dir ein optimales Nutzererlebnis zu bieten. Cookies sind kleine Textdateien, die wir auf deinem Computer, Tablet oder Smartphone speichern. Sie helfen dir, bequem durch den Dienst zu navigieren und bestimmte Features in Anspruch zu nehmen. Dazu zählen Cookies, die für den technischen Betrieb des Dienstes notwendig sind, sowie solche, die zu Statistikzwecken, für Komforteinstellungen, oder zur Anzeige personalisierter Inhalte genutzt werden."
]
};
